/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";

import "../../App.css";
import { Card, Form, Select, Checkbox, InputNumber } from "antd";
import Jax from "../../Jax/jax.es6.module";
import TableIDs from "../../data/TableIDs";
import { DatePicker, TimePicker } from 'antd';
import moment from "moment";
import PageToolbar from "../../components/PageToolbar";
import LangContext from "../../contextProvider/LangContext";
import ReportTypeButton from "../../components/ReportTypeButton";
import { disabledDatePicker } from "../../utils/utils";
import GenericSelectorPosStorages from "../../components/GenericSelectorPosStorages";

const FormItem = Form.Item;
const { Option, OptGroup } = Select;

type Props = {
    user: any,
    ui: any,
    uiActions: any,
    baseUrl: string,
    data: Object,
    dataActions: Object,
    ActionQueue: any
};
type State = {};

class PaymentDetailedReport extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            endOpen: false,
            PaymentDetailed: {
                DocumentPaymentTypes: '',
                StorageListIssue: '',
                ItemTagList: '',
                EmployeeList: '',
                PosList: '',
                LowerSelectionDate: moment().add(-1, "month").format("YYYY-MM-01"),
                UpperSelectionDate: moment().format("YYYY-MM-DD"),
                LowerSelectionTime: "00:00:00",
                UpperSelectionTime: "23:59:59",
                ApplyRangeApply: 0,
                ApplyRangeLowerUse: 0,
                ApplyRangeUpperUse: 0,
                reportName: "reports/paymentDetails.pdf",
            }
        };

        this.state.type = "pdf";
        this.state.RequestedReport = "Tags"; // Tags // Suppliers

        if (props.data[TableIDs.genericSelectorPos] === undefined) {
            props.data[TableIDs.genericSelectorPos] = { ...props.data.genericSelector };
        }
        //if (props.data[TableIDs.genericSelectorEmployees] === undefined) {
        //    props.data[TableIDs.genericSelectorEmployees] = { ...props.data.genericSelector };
        //}
        if (props.data[TableIDs.genericMultiSelectorItemTags] === undefined) {
            props.data[TableIDs.genericMultiSelectorItemTags] = { ...props.data.genericSelector };
        }
        if (props.data[TableIDs.genericSelectorStorages] === undefined) {
            props.data[TableIDs.genericSelectorStorages] = { ...props.data.genericSelector };
        }
        if (props.data[TableIDs.genericSelectorItemGroup] === undefined) { //////
            props.data[TableIDs.genericSelectorItemGroup] = { ...props.data.genericSelector };
        }
        if (props.data[TableIDs.genericSelectorItemTagTypes] === undefined) { //////
            props.data[TableIDs.genericSelectorItemTagTypes] = { ...props.data.genericSelector };
        }
        if (props.data[TableIDs.genericSelectorPaymentTypes] === undefined) { //////
            props.data[TableIDs.genericSelectorPaymentTypes] = { ...props.data.genericSelector };
        }
        //if (props.data[TableIDs.genericSelectorSuppliers] === undefined) {
        //    props.data[TableIDs.genericSelectorSuppliers] = { ...props.data.genericSelector };
        //}

        this.api = {
            selector_pos: "list_pos",
            selector_employees: "get_employee_list",
            selectorMulti_itemtag: "get_tags_with_types",
            selector_storages: "get_storage_list",
            selector_item_tagTypes: "get_tag_types_with_relation_list",//
            selector_item_group: "get_item_group_list",
            selector_supplier: "get_suppliers",
            selector_payment_types: "get_payment_types_list",
        }

        this.props.dataActions.genericSelectorRefreshDataset(
            TableIDs.genericSelectorPos, this.props.user.companyCode, this.props.user.token, this.api.selector_pos);
        this.props.dataActions.genericSelectorRefreshDataset(
            TableIDs.genericSelectorEmployees, this.props.user.companyCode, this.props.user.token, this.api.selector_employees);
        this.props.dataActions.genericMultiSelectorRefreshDataset(
            TableIDs.genericMultiSelectorItemTags, this.props.user.companyCode, this.props.user.token, this.api.selectorMulti_itemtag);
        this.props.dataActions.genericSelectorRefreshDataset(
            TableIDs.genericSelectorStorages, this.props.user.companyCode, this.props.user.token, this.api.selector_storages);
        this.props.dataActions.genericSelectorRefreshDataset(
            TableIDs.genericSelectorItemTagTypes, this.props.user.companyCode, this.props.user.token, this.api.selector_item_tagTypes);//
        this.props.dataActions.genericSelectorRefreshDataset(
            TableIDs.genericSelectorItemGroup, this.props.user.companyCode, this.props.user.token, this.api.selector_item_group); //
        this.props.dataActions.genericSelectorRefreshDataset(
            TableIDs.genericSelectorPaymentTypes, this.props.user.companyCode, this.props.user.token, this.api.selector_payment_types); //

        //this.props.dataActions.genericSelectorRefreshDataset(
        //    TableIDs.genericSelectorSuppliers, this.props.user.companyCode, this.props.user.token, this.api.selector_supplier);
    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidMount() {
        this.loadData();
    }

    setReportParameters(report: string, params: Object) {
        let newState = Jax.mutate(this.state || {}, report, params);
        this.setState(newState);
    }

    generateReport(report: string) {
        let params = Jax.get(this.state || {}, report, null);
        if (params !== null && params.reportName) {
            window.console.log("Generating report...");
            params = this.getFullSelector(params);
            params = { ...params, REPORT_LOCALE: this.getText(101) }
            // console.log("yuda params ", params)
            this.props.ActionQueue.addToQueue({ action: this.props.dataActions.generateReport, args: [this.props.user.companyCode, this.props.user.token, params] });
        }
    }

    getFullSelector = (params) => {
        let fullPosList = this.props.data[TableIDs.genericSelectorPos].dataset.map((obj) => obj['code']).join(',');
        let fullStoragesList = this.props.data[TableIDs.genericSelectorStorages].dataset.map((obj) => obj['code']).join(',');
        if (params.PosList === '') params = { ...params, PosList: fullPosList }
        if (params.StorageListIssue === '') params = { ...params, StorageListIssue: fullStoragesList }
        return params;
    }

    componentDidUpdate(prevProps) {
        document.title = "Cash On Tab - " + this.getText(10192);
        let posList = this.props.data[TableIDs.genericSelectorPos];
        let storagesList = this.props.data[TableIDs.genericSelectorStorages];

        if (
            posList && posList.dataset[0]
            &&
            storagesList && storagesList.dataset[0]
            && !this.state.loading
        ) {
            this.setState({ loading: true })
        }

        if (prevProps.ui.favoriteParams !== this.props.ui.favoriteParams) {
            this.setReportParameters("PaymentDetailed", this.props.ui.favoriteParams)
        }

    }

    loadData() {
        this.props.ActionQueue.addToQueue({
            action: this.props.dataActions.genericSelectorRefreshDataset,
            args: [TableIDs.genericSelectorPos, this.props.user.companyCode, this.props.user.token, this.api.selector_pos]
        });
        this.props.ActionQueue.addToQueue({
            action: this.props.dataActions.genericSelectorRefreshDataset,
            args: [TableIDs.genericSelectorEmployees, this.props.user.companyCode, this.props.user.token, this.api.selector_employees]
        });
        this.props.ActionQueue.addToQueue({
            action: this.props.dataActions.genericMultiSelectorRefreshDataset,
            args: [TableIDs.genericMultiSelectorItemTags, this.props.user.companyCode, this.props.user.token, this.api.selectorMulti_itemtag]
        });
        this.props.ActionQueue.addToQueue({
            action: this.props.dataActions.genericSelectorRefreshDataset,
            args: [TableIDs.genericSelectorStorages, this.props.user.companyCode, this.props.user.token, this.api.selector_storages]
        });
        this.props.ActionQueue.addToQueue({
            action: this.props.dataActions.genericSelectorRefreshDataset,
            args: [TableIDs.genericSelectorItemTagTypes, this.props.user.companyCode, this.props.user.token, this.api.selector_item_tagTypes]
        });
        this.props.ActionQueue.addToQueue({
            action: this.props.dataActions.genericSelectorRefreshDataset,
            args: [TableIDs.genericSelectorItemGroup, this.props.user.companyCode, this.props.user.token, this.api.selector_item_group]
        });
        this.props.ActionQueue.addToQueue({
            action: this.props.dataActions.genericSelectorRefreshDataset,
            args: [TableIDs.genericSelectorPaymentTypes, this.props.user.companyCode, this.props.user.token, this.api.selector_payment_types]
        });
        //this.props.ActionQueue.addToQueue({
        //    action: this.props.dataActions.genericSelectorRefreshDataset,
        //    args: [TableIDs.genericSelectorSuppliers, this.props.user.companyCode, this.props.user.token, this.api.selector_supplier]
        //});
    }
    disabledStartDate = (FromDate) => {
        const ToDate = this.state.PaymentDetailed.LowerSelectionDate;
        if (!FromDate || !ToDate) {
            return false;
        }
        return FromDate.valueOf() > ToDate.valueOf();
    }

    disabledEndDate = (ToDate) => {
        const FromDate = this.state.PaymentDetailed.UpperSelectionDate;
        if (!ToDate || !FromDate) {
            return false;
        }
        return ToDate.valueOf() <= FromDate.valueOf();
    }

    /*
    onChange = (field, value) => {
        this.setReportParameters("PaymentDetailed", { [field]: value })
        this.setState({
            [field]: value,
        });
    }*/

    onChange = (field, value, field2, value2) => {
        //console.log("f ",field ,"v ", value);
        this.setReportParameters("PaymentDetailed", { [field]: value, [field2]: value2 })
    }

    onStartChange = (value) => {
        let arr = (value ? value.format("YYYY-MM-DD#HH:mm:ss") : '').split('#');;
        // console.log("start date ", arr);
        this.onChange('LowerSelectionDate', arr[0], 'LowerSelectionTime', arr[1]);
    }

    onEndChange = (value) => {
        let arr = (value ? value.format("YYYY-MM-DD#HH:mm:ss") : '').split('#');;
        // console.log("yuda end date ", arr);
        this.onChange('UpperSelectionDate', arr[0], 'UpperSelectionTime', arr[1]);
    }

    createCheckBox = (field, data) => {
        return (
            <Checkbox
                style={{ display: 'inline' }}
                onChange={(e) => {
                    if (e.target.checked)
                        this.setReportParameters("PaymentDetailed", { [field]: data });
                    else
                        this.setReportParameters("PaymentDetailed", { [field]: '' });
                }} />);
    }

    render() {
        const { PaymentDetailed, endOpen } = this.state;
        const { LowerSelectionDate, LowerSelectionTime,
            UpperSelectionDate, UpperSelectionTime } = PaymentDetailed;

        const divStyle = {
            align: "center",
            dir: "rtl", // dir: 'ltr'
            padding: "2% 2% 2% 2%",

            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            flexDirection: 'column',
        };

        //const { PaymentDetailed } = this.state;
        const isMinPercShownStyle = { display: (PaymentDetailed.RequestedReport === 5 || PaymentDetailed.RequestedReport === 6) ? 'block' : 'none' }

        let listPos = Jax.get(this.props.data, TableIDs.genericSelectorPos + ".dataset", []).map((obj, index) => {
            return (<Option key={obj['code']} value={obj['code']}>{obj['code'] + '-' + obj['name']}</Option>)
        });
        let listEmployee = Jax.get(this.props.data, TableIDs.genericSelectorEmployees + ".dataset", []).map((obj, index) => {
            return (<Option key={obj['code']} value={obj['code']}>{obj['code'] + '-' + obj['name']}</Option>)
        });

        let listItemTags = Jax.get(this.props.data, TableIDs.genericMultiSelectorItemTags + ".dataset", []).map(
            (node: TagObj, index) => {
                return (
                    <OptGroup label={node.type.text} key={"type_" + node.type.id}>
                        {node.tags.map((item: string, index) => {
                            return (<Option key={"tag_" + item.id} value={item.id} valuefilter={item.text}>{item.text}</Option>)
                        })}
                    </OptGroup>
                )
            }
        )

        let listStorage = Jax.get(this.props.data, TableIDs.genericSelectorStorages + ".dataset", []).map((obj, index) => {
            return (<Option key={obj['code']} value={obj['code']}>{obj['code'] + '-' + obj['name']}</Option>)
        });
        let listItemTagTypes = Jax.get(this.props.data, TableIDs.genericSelectorItemTagTypes + ".dataset", []).map((obj, index) => {
            return (<Option key={obj['code']} value={obj['code']}>{obj['code'] + '-' + obj['name']}</Option>)
        });
        let listItemGroup = Jax.get(this.props.data, TableIDs.genericSelectorItemGroup + ".dataset", []).map((obj, index) => {
            return (<Option key={obj['code']} value={obj['code']}>{obj['code'] + '-' + obj['name']}</Option>)
        });
        //let listSuppliers = Jax.get(this.props.data, TableIDs.genericSelectorSuppliers + ".dataset", []).map((obj, index) => {
        //    return (<Option key={obj['code']} value={obj['code']}>{obj['code'] + '-' + obj['name']}</Option>)
        //});
        let listPayments = Jax.get(this.props.data, TableIDs.genericSelectorPaymentTypes + ".dataset", []).map((obj, index) => {
            return (<Option key={obj['code']} value={obj['code']}>{obj['code'] + '-' + obj['name']}</Option>)
        });

        let mobile = window.innerWidth > 600 ? false : true;

        return (
            <div style={divStyle} >
                <Card title={(<PageToolbar title={this.getText(12196)} showsearch={false} actionButtons={[]} />)}
                    bordered={true} style={{ width: mobile ? '95%' : '60%' }}
                    headStyle={{ paddingLeft: 8, paddingRight: 8, marginTop: 4, height: 56 }}>

                    <Form className="data-entry-form" layout='horizontal' //layout='vertical' //'horizontal' // inline  |'vertical'|'inline'
                        style={{ columnWidth: 'auto', columnCount: mobile ? '1' : '2', paddingTop: mobile ? 50 : 0 }}
                        onSubmit={this.handleSaveChanges}
                    >
                        <FormItem label={this.getText(12197)} /*LowerSelectionDate - LowerSEleCtionTime*/>
                            <DatePicker
                                //  disabledDate={this.disabledStartDate}
                                // disabledDate={d => disabledDatePicker(d, null, UpperSelectionDate)}
                                disabledDate={d => disabledDatePicker(d,
                                    UpperSelectionDate ? moment(UpperSelectionDate).add(-370, "days").format("YYYY-MM-DD") : null,
                                    UpperSelectionDate)}

                                format="DD-MM-YYYY"//"YYYY-MM-DD"
                                placeholder={this.getText(12210)}
                                value={LowerSelectionDate ? moment(LowerSelectionDate, "YYYY-MM-DD") : null}
                                onChange={(value) => {
                                    this.setReportParameters("PaymentDetailed", {
                                        LowerSelectionDate: value ? value.format("YYYY-MM-DD") : null,
                                    })
                                }}
                            />
                            <TimePicker
                                format="HH:mm:ss"
                                value={LowerSelectionTime ? moment(LowerSelectionTime, "HH:mm:ss") : null}
                                onChange={(value) => {
                                    this.setReportParameters("PaymentDetailed", {
                                        LowerSelectionTime: value ? value.format("HH:mm:ss") : null,
                                    })
                                }}
                            />

                        </FormItem>

                        <FormItem label={this.getText(12198)} /*style={isEndDateShownStyle}*/>
                            <DatePicker
                                //  disabledDate={this.disabledEndDate}
                                // disabledDate={d => disabledDatePicker(d, LowerSelectionDate, null)}
                                disabledDate={d => disabledDatePicker(d,
                                    LowerSelectionDate,
                                    LowerSelectionDate ? moment(LowerSelectionDate).add(370, "days").format("YYYY-MM-DD") : null)}

                                format="DD-MM-YYYY"//"YYYY-MM-DD"
                                placeholder={this.getText(12209)}
                                value={UpperSelectionDate ? moment(UpperSelectionDate, "YYYY-MM-DD") : null}
                                onChange={(value) => {
                                    this.setReportParameters("PaymentDetailed", {
                                        UpperSelectionDate: value ? value.format("YYYY-MM-DD") : null,
                                    })
                                }}
                            />
                            <TimePicker
                                format="HH:mm:ss"
                                value={UpperSelectionTime ? moment(UpperSelectionTime, "HH:mm:ss") : null}
                                onChange={(value) => {
                                    this.setReportParameters("PaymentDetailed", {
                                        UpperSelectionTime: value ? value.format("HH:mm:ss") : null,
                                    })
                                }}
                            />
                        </FormItem>

                        <FormItem label={this.getText(12199)}>
                            <GenericSelectorPosStorages  {...this.props} multi
                                onChange={(value, typeList) => this.setReportParameters("PaymentDetailed", { PosList: value.join(','), StorageListIssue: typeList.join(',') })}
                                value={(this.state.PaymentDetailed.PosList === '') ? [] : this.state.PaymentDetailed.PosList.split(',')}
                            />
                            {/* {this.createCheckBox('PosList', Jax.get(this.props.data, TableIDs.genericSelectorPos + ".dataset", []).map((obj, index) => obj['code']).join(','))}
                            <Select key={"PosList"} style={{ width: '90%' }}
                                mode="multiple"
                                maxTagCount={4}
                                //placeholder="Please select"
                                //className={""}
                                //defaultValue={1}
                                onChange={(value) => this.setReportParameters("PaymentDetailed", { PosList: value.join(',') })}
                                value={(this.state.PaymentDetailed.PosList === '') ? [] : this.state.PaymentDetailed.PosList.split(',')}
                            >
                                {listPos}
                            </Select> */}
                        </FormItem>

                        {/* <FormItem label={this.getText(12200)}>
                            {this.createCheckBox('StorageListIssue', Jax.get(this.props.data, TableIDs.genericSelectorStorages + ".dataset", []).map((obj, index) => obj['code']).join(','))}
                            <Select key={"StorageListIssue"} style={{ width: '90%' }}
                                mode="multiple"
                                maxTagCount={4}
                                //placeholder="Please select"
                                //className={""}
                                //defaultValue={1}
                                onChange={(value) => this.setReportParameters("PaymentDetailed", { StorageListIssue: value.join(',') })}
                                value={(this.state.PaymentDetailed.StorageListIssue === '') ? [] : this.state.PaymentDetailed.StorageListIssue.split(',')}
                            >
                                {listStorage}
                            </Select>
                        </FormItem> */}

                        <FormItem label={this.getText(12201)}>
                            {this.createCheckBox('DocumentPaymentTypes', Jax.get(this.props.data, TableIDs.genericSelectorPaymentTypes + ".dataset", []).map((obj, index) => obj['code']).join(','))}
                            <Select key={"DocumentPaymentTypes"} style={{ width: '90%' }}
                                mode="multiple"
                                maxTagCount={4}
                                //placeholder="Please select"
                                //className={""}
                                //defaultValue={1}
                                onChange={(value) => this.setReportParameters("PaymentDetailed", { DocumentPaymentTypes: value.join(',') })}
                                value={(this.state.PaymentDetailed.DocumentPaymentTypes === '') ? [] : this.state.PaymentDetailed.DocumentPaymentTypes.split(',')}
                            >
                                {listPayments}
                            </Select>
                        </FormItem>

                        <FormItem label={this.getText(12202)} style={{ width: "100%" }}>
                            {this.createCheckBox('EmployeeList', Jax.get(this.props.data, TableIDs.genericSelectorEmployees + ".dataset", []).map((obj, index) => obj['code']).join(','))}
                            <Select key={"EmployeeList"} style={{ width: "90%" }}
                                mode="multiple"
                                maxTagCount={4}
                                //placeholder="Please select"
                                //className={""}
                                //defaultValue={1}
                                onChange={(value) => this.setReportParameters("PaymentDetailed", { EmployeeList: value.join(',') })}
                                value={(this.state.PaymentDetailed.EmployeeList === '') ? [] : this.state.PaymentDetailed.EmployeeList.split(',')}
                            >
                                {listEmployee}
                            </Select>
                        </FormItem>

                        <FormItem label={this.getText(12203)}>
                            <Checkbox
                                //onChange={this.handleCheckBoxRange}
                                //ApplyRange_Apply
                                //checked={(this.props.data[this.id].editedRecord['mIsActive'] == 1) ? true : false}
                                checked={this.state.PaymentDetailed.ApplyRangeApply == 1}
                                onChange={(value) => this.setReportParameters("PaymentDetailed", { ApplyRangeApply: (value.target.checked) ? 1 : 0 })}
                                style={{ marginLeft: '4px' }}
                            />
                            <InputNumber
                                //ApplyRange_Lower
                                value={this.state.PaymentDetailed.ApplyRangeLowerUse}
                                onChange={(value) => this.setReportParameters("PaymentDetailed", { ApplyRangeLowerUse: value })}
                                disabled={this.state.PaymentDetailed.ApplyRangeApply != 1}
                                style={{ marginLeft: '4px' }}
                            />
                            <InputNumber
                                //ApplyRange_Upper
                                value={this.state.PaymentDetailed.ApplyRangeUpperUse}
                                onChange={(value) => this.setReportParameters("PaymentDetailed", { ApplyRangeUpperUse: value })}
                                disabled={this.state.PaymentDetailed.ApplyRangeApply != 1}
                                style={{ marginLeft: '4px' }}
                            />
                        </FormItem>

                        <ReportTypeButton
                            {...this.props}
                            params={this.state.PaymentDetailed}
                            storagesField={'StorageListIssue'}
                            posField={'PosList'}
                            datesToFavorites={[
                                { field: 'LowerSelectionDate', label: this.getText(12197) },
                                { field: 'UpperSelectionDate', label: this.getText(12198) },
                            ]}
                            favoriteSave
                        />

                        {/* <FormItem key={"reportName"} label={this.getText(12204)}>
                            <Select style={{ width: 250 }}
                                //size={"large"}
                                className={"reports/PaymentDetailed.pdf"}
                                //combobox={null}
                                defaultValue={"pdf"}
                                onChange={(value) => {
                                    //const type = this.state.PaymentDetailed.mRequestedReport;
                                    //console.log(type);
                                    //const str = (type === 0) ? '' : type.toString();
                                    //console.log(value,str);
                                    //this.setReportParameters("PaymentDetailed", { reportName: "reports/PaymentDetailed" + str + ".pdf"})}
                                    //this.setState({ ...this.state, type: value });
                                    this.setReportParameters("PaymentDetailed",
                                        {
                                            reportName: "reports/paymentDetails." + value,
                                            type: value
                                        });

                                }}
                            >
                                <Option key={"pdf"}>{this.getText(12205)}</Option>
                                <Option key={"xls"}>{this.getText(12206)}</Option>
                                <Option key={"docx"}>{this.getText(12207)}</Option>
                            </Select>
                        </FormItem>
                        <FormItem key={"submit"}>
                            <Button type={"primary"} onClick={() => {
                                //const type = this.state.RequestedReport;
                                this.generateReport.apply(this, ["PaymentDetailed"])
                            }}>{this.getText(12208)}</Button>
                        </FormItem> */}
                    </Form>
                </Card>
            </div>
        );
    }
}
export default PaymentDetailedReport;
